import script from "./TaxableLineItemHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TaxableLineItemHeader.vue?vue&type=script&setup=true&lang=js"

import "./TaxableLineItemHeader.vue?vue&type=style&index=0&id=3554ebc7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3554ebc7"]])

export default __exports__